// Application configuration
export default {
  serverUrl: 'https://apptest.warhall.eu'
};
